import React, { createContext, useContext, useState, useEffect } from 'react';
import { ThemeUtils, THEME_CONSTANTS, THEME_TYPES } from '@/utils/themeUtils';
import qs from 'qs';

export { THEME_TYPES };

// 创建主题上下文
const ThemeContext = createContext();

// 从URL参数获取主题
const getThemeFromURL = () => {
  if (typeof window === 'undefined') return null;
  const query = qs.parse(window.location.search, { ignoreQueryPrefix: true });
  const urlTheme = query?.theme?.toLowerCase();
  if (urlTheme === THEME_TYPES.DARK || urlTheme === THEME_TYPES.LIGHT) {
    return urlTheme;
  }
  return null;
};

// 主题提供者组件
export const ThemeProvider = ({ children }) => {
  // 优先从URL参数获取主题，如果没有则从localStorage获取，默认为light
  const [theme, setTheme] = useState(() => {
    const urlTheme = getThemeFromURL();
    if (urlTheme) {
      // 如果URL中有主题参数，设置并返回
      ThemeUtils.setTheme(urlTheme);
      return urlTheme;
    }
    ThemeUtils.setTheme(THEME_TYPES.LIGHT);
    return THEME_TYPES.LIGHT;
  });

  // 切换主题
  const toggleTheme = () => {
    const newTheme = ThemeUtils.toggleTheme();
    setTheme(newTheme);
  };

  // 设置特定主题
  const setThemeType = (themeType) => {
    if (Object.values(THEME_TYPES).includes(themeType)) {
      ThemeUtils.setTheme(themeType);
      setTheme(themeType);
    }
  };


  // 设置主题类名
  useEffect(() => {
    // 设置根元素的主题类名
    document.documentElement.setAttribute(THEME_CONSTANTS.DATA_ATTRIBUTE, theme);
    document.body.className = document.body.className.replace(new RegExp(`${THEME_CONSTANTS.CLASS_PREFIX}\\w+`, 'g'), '');
    document.body.classList.add(`${THEME_CONSTANTS.CLASS_PREFIX}${theme}`);
  }, [theme]);

  const value = {
    theme,
    toggleTheme,
    setThemeType,
    isDark: theme === THEME_TYPES.DARK,
    isLight: theme === THEME_TYPES.LIGHT
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

// 使用主题的Hook
export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

// 高阶组件，用于为组件注入主题
export const withTheme = (Component) => {
  return (props) => {
    const theme = useTheme();
    return <Component {...props} theme={theme} />;
  };
};

export default ThemeContext;
